import styles from './Section.module.scss';
import { type ReactNode } from 'react';
import { HeadingContextProvider } from '../text/HeadingContext';
import { HeadingShared } from '../text/HeadingShared';

interface Props {
  children: ReactNode;
  heading: string;
  spacing?: 'default' | 'top' | 'bottom';
  contained?: boolean;
  addon?: ReactNode;
}

export function Section({ contained, ...props }: Props) {
  const { spacing = 'default' } = props;
  const sectionClassName = [
    styles['section'],
    contained && styles['section-contained'],
    styles['section-spacing-' + spacing],
  ]
    .filter(Boolean)
    .join(' ');

  const heading = props.heading != null && (
    <HeadingShared
      classNames={{ root: styles['top'] }}
      end={props.addon}
      level={2}
      spacing="bottom"
    >
      {props.heading}
    </HeadingShared>
  );

  return (
    <section className={sectionClassName}>
      {/* <div className={styles['top']}>
        <div className={styles['heading']}>{heading}</div>
        {props.addon && <div className={styles['addon']}>{props.addon}</div>}
      </div> */}
      {heading}
      <div>
        <HeadingContextProvider>{props.children}</HeadingContextProvider>
      </div>
    </section>
  );
}
